import {Component, ElementRef, Input, OnChanges, OnInit} from '@angular/core';

@Component({
    selector: 'app-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    standalone: false
})
export class TabComponent implements OnInit, OnChanges {

  @Input() label?: string;
  @Input() routerLink?: string;

  constructor(
    private el: ElementRef
  ) { }

  ngOnInit(): void {
    this.setDataAttribute();
  }

  ngOnChanges() {
    this.setDataAttribute();
  }

  setDataAttribute(): void {
    this.el.nativeElement.dataset['label'] = this.label;
    this.el.nativeElement.dataset['routerLink'] = this.routerLink ?? '';
  }
}
